'use strict';


/** @namespace */
module.exports = {
    layouts: {
        // tv channel item with playback and current program
        tvChannel: 1,
        // movie preview
        video: 2,
        // record status and progress
        record: 3,
        // default layout
        static: 4,
        // application layout
        application: 5
    },
    geometry: {
        square: 1,
        horizontal: 2,
        vertical: 3,
        round: 4
    },
    actions: {
        // actions which can be applied to item
        favorite: 1,
        accessControl: 2,
        expandItemContent: 3
    }
};
